'use strict';

var Reflux = require('reflux');

module.exports = Reflux.createActions([
    'reloadExperiment',

    'viewedItem',

    'addItem',
    'setItemQuantity',
    'setItemNote',
    'setBudgetEstimate',
    'setProjectField',

    'setSessionStartTime',
    'setDidGreet',
    'setShowChat',

    'reset',
    'submit',
]);



// WEBPACK FOOTER //
// ./src/store/actions.js